import { useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";

const OTPInput = ({ size, secondsRemaining, formik }) => {
  const handleChange = (value, index) => {
    const newArray = [...formik.values.otp];
    newArray[index] = value.slice(-1);
    formik.setFieldValue("otp", newArray);
    value && arrRef.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (!e.target.value && e.key === "Backspace") {
      arrRef.current[index - 1]?.focus();
    }
  };
  const arrRef = useRef([]);

  useEffect(() => {
    arrRef.current[0]?.focus();
  }, []);

  return (
    <>
      <form autoComplete="off">
        <div className="d-flex">
          <p className="mb-1">{`Verify OTP (It will be expire in ${secondsRemaining} seconds)`}</p>
          <p className="erroStar">*</p>
        </div>
        <div className="row" style={{ marginTop: "10px" }}>
          {formik.values.otp.map((input, index) => {
            return (
              <>
                <div key={index} className="col-md-1">
                  <TextField
                    type="number"
                    value={formik.values.otp[index]}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputRef={(input) => (arrRef.current[index] = input)}
                    onChange={(e) => handleChange(e.target.value, index)}
                  ></TextField>
                </div>
              </>
            );
          })}
        </div>
      </form>
    </>
  );
};
export default OTPInput;
